import React, { useState, useEffect } from 'react';
import TabelaResultado from '../TabelaResultado'; // Importe o componente TabelaResultado
import { useDevice } from 'components/DeviceContext.js';
import {Grid} from '@material-ui/core'

function SelectConsulteMunicipio() {
    const { isMobile } = useDevice();
    const [ufs, setUfs] = useState([]);
    const [selectedUF, setSelectedUF] = useState('');
    const [municipios, setMunicipios] = useState([]);
    const [selectedMunicipio, setSelectedMunicipio] = useState('');
    const [resultadoPesquisa, setResultadoPesquisa] = useState([]);
    const [pesquisaRealizada, setPesquisaRealizada] = useState(false);

    useEffect(() => {
        carregarUFs();
    }, []);

    const carregarUFs = () => {
        fetch('https://contatos.cnm.org.br/api/list/estados')
            .then(response => response.json())
            .then(data => {
                setUfs(data);
            })
            .catch(error => console.error('Erro ao carregar UFs:', error));
    };

    const carregarMunicipios = (ibge) => {
        fetch(`https://contatos.cnm.org.br/api/list/municipios/${ibge}`)
            .then(response => response.json())
            .then(data => {
                console.log('Municípios:', data);
                setMunicipios(data);
            })
            .catch(error => console.error('Erro ao carregar municípios:', error));
    };

    const handleUFChange = (e) => {
        const uf = e.target.value;
        setSelectedUF(uf);
        carregarMunicipios(uf);
    };

    const handleMunicipioChange = (e) => {
        const municipioId = e.target.value;
        setSelectedMunicipio(municipioId);
    };

    const handlePesquisarClick = () => {
        if (selectedUF && selectedMunicipio) {
            const uf = selectedUF;
            const ibge = selectedMunicipio;

            fetch(`https://apifia.cnm.org.br/api/buscar-dados/${uf}/${ibge}`, {
                method: 'GET'
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Resultado da pesquisa:', data);
                    setResultadoPesquisa(data);
                    setPesquisaRealizada(true); // Define a flag para verdadeiro após a pesquisa
                })
                .catch(error => console.error('Erro ao buscar dados:', error));
        } else {
            console.error('UF e/ou município não selecionados');
        }
    };

    return (
        <Grid style={{ fontFamily: 'Arial, sans-serif', border: '1px solid #ccc', borderRadius: '5px', display: isMobile ? 'flex' : '', flexDirection: 'column', backgroundColor: 'var(--azul)' }}>
            <Grid>
                <h1 style={{paddingLeft: '0.6em', color: 'var(--branco)'}}>Consulte seu município</h1>
            </Grid>
            <Grid style={{backgroundColor: 'white', padding: '2em',}}>

            <label htmlFor="selectUF" style={{ marginRight: '10px' }}></label>
            <select id="selectUF" value={selectedUF} onChange={handleUFChange} style={{ padding: '5px', borderRadius: '5px' }}>
                <option value="">Selecione a UF</option>
                {ufs.map(uf => (
                    <option key={uf.sigla} value={uf.sigla}>{uf.sigla}</option>
                ))}
            </select>

            <label htmlFor="selectMunicipio" style={{ marginRight: '10px', marginTop: '10px' }}></label>
            <select id="selectMunicipio" value={selectedMunicipio} onChange={handleMunicipioChange} style={{ padding: '5px', borderRadius: '5px' }}>
                <option value="">Selecione o Município</option>
                {municipios.map(municipio => (
                    <option key={municipio.ibge} value={municipio.ibge}>{municipio.descricao}</option>
                ))}
            </select>
            <button onClick={handlePesquisarClick} style={{ margin: '10px', padding: '8px 15px', borderRadius: '5px', backgroundColor: '#007bff', color: '#fff', border: 'none', cursor: 'pointer' }}>Pesquisar</button>
            {pesquisaRealizada && resultadoPesquisa.length > 0 ? (
                <TabelaResultado resultados={resultadoPesquisa} />
            ) : null}

            {pesquisaRealizada && resultadoPesquisa.length === 0 ? (
                <p>Nenhuma informação do município encontrada</p>
            ) : null}
            </Grid>
        </Grid>
    );
}

export default SelectConsulteMunicipio;
